<template>
  <div class="reports">
      <div class="md-title">My Saved Carts</div>       
      <md-empty-state v-if="!$store.state.settings.userId"
            md-icon="lock"
            md-label="Not Logged In"
            md-description="When you set your UserId in Settings, you'll see your saved reports here">
      </md-empty-state>   


      <md-empty-state v-if="!myCarts.length && $store.state.settings.userId"
        md-icon="shopping_cart"
        md-label="No Saved Carts"
        md-description="When you carts, theyll show up here.">
      </md-empty-state>   
       
       
       <md-list v-if="myCarts">
        <md-list-item v-bind:key="index" v-for="(c, index) in myCarts">
            <div class="md-list-item-text">
                <span>{{c.name}}</span>
                <span>{{c.date}}</span>
            </div>
            <md-button :to="{ name: 'singleReport', params: { cartId: c.name }}">View</md-button>
        </md-list-item>

       </md-list>
  </div>
</template>

<script>
import * as firebase from 'firebase/app';
import 'firebase/firestore';

export default {
  name: 'Reports',
  data () {
    return {
        myCarts:[]
    }
  },
  computed: {
      
  },

  methods: {

      carts: function (){
            let that = this;
            if(this.$store.state.settings.userId) {
                var db = firebase.firestore();
                var ret = [];
                var cartsRef = db.collection("users")
                .doc(this.$store.state.settings.userId)
                .collection("carts").orderBy("dateSaved", "desc");
                cartsRef.get().then(

                    function(querySnapshot) {
                        querySnapshot.forEach(function(doc) {
                            // doc.data() is never undefined for query doc snapshots
                            let d = doc.data();
                            that.myCarts.push({
                                name:doc.id,
                                date:d.dateSaved.toDate().toString(),
                                items:d.items
                            });
                        });  
                    }

                );
          }
      }

  },

  mounted: function () {
    this.carts();
    //console.log(this.myCarts);
  },
  props: {
      
  }
}

</script>
